/* eslint-disable no-undef, jsx-a11y/anchor-is-valid, class-methods-use-this */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import Cookies from 'js-cookie';
import { Modal } from 'react-bootstrap';
import MapComponent from '../CountryComponent/ListViewLeftPart/MapComponent/MapComponent';
import './CityLeftPartComponent.sass';
import CheckboxComponent from './CheckBoxComponent';
import ReadMore from '../SharedComponents/ReadMore/ReadMore';
import httpService from '../../../api/httpLocationService';
import { StarRateIcon } from '../SharedComponents/Icons';
import rentedImage from '../../../../assets/images/rented-out.png';
import newLocationImage from '../../../../assets/images/new-location-image.png';
import ReactPaginate from 'react-paginate';
import queryString from 'query-string';
import { Experiment, Variant, emitter } from '@marvelapp/react-ab-test';

emitter.defineVariants('lock-test', ['with-lock-list', 'without-lock-list'], [50, 50]);

class CityLeftPartComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      locIdsOrdered: [],
      locationList: [],
      showOrderedModal: false,
      isDescBodyShown: false,
      defaultPage: 1,
      currentPage: 1,
      pagesCount: 0,
      areas: props.area.id,
      staticImageAvailable: true,
      isMapHovering: false,
      selectedAll: true,
    };

    this.httpService = httpService;

    this.handleChange = this.handleChange.bind(this);
    this.handleLocationOrderedModal = this.handleLocationOrderedModal.bind(this);
    this.handleLocationModalClose = this.handleLocationModalClose.bind(this);
    this.handleReadMoreClick = this.handleReadMoreClick.bind(this);
    this.handleReadLessClick = this.handleReadLessClick.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
  }

  onBackButtonEvent(e) {
    const getPath = queryString.parse(window.location.search);
    const pathKeys = Object.keys(getPath);

    if (pathKeys.includes("page")) {
      this.getLocationsList(this.state.areas, getPath.page )
    } else {
      this.getLocationsList(this.state.areas);
    }
  }

  componentDidMount() {
    this.props.mapUrlLv ? this.setState({ staticImageAvailable: true }) : this.setState({ staticImageAvailable: false });
    this.props.onComponentDidMount(this.props.area.id, this.props.kind);
    const getPath = queryString.parse(window.location.search);
    const pathKeys = Object.keys(getPath);

    if (pathKeys.includes("page")) {
      this.getLocationsList(this.state.areas, getPath.page, null )

    } else {
      this.getLocationsList(this.state.areas );
    }
    window.onpopstate = (e) => this.onBackButtonEvent(e)
  }

  sendGoogleData = (locationList) => {
    const locationListForGoogle = [];
    const orderedLocationIds = [];
    const locationsIds = locationList.map(elem => elem.loc_id);

    if (locationsIds.length > 0) {
      this.trackDynamicRemarketing(locationsIds);
    }
    locationsIds.map((elem) => {
      if (Cookies.getJSON(`order${elem}`)) {
        orderedLocationIds.push(Cookies.getJSON(`order${elem}`));
        this.setState({
          locIdsOrdered: orderedLocationIds,
        });
      }

      return orderedLocationIds;
    });


    if (typeof gtag === 'function') {
      locationList.forEach((location, index) => {
        const gtagData = {
          id: location.loc_id,
          name: location.localized_info.heading,
          list: 'Catalog',
          category: location.localized_info.category_for_ga,
          list_position: index + 1,
        };

        if (index > 2) {
          gtagData.price = '1.0';
        }
        locationListForGoogle.push(gtagData);
      });

      gtag('event', 'view_item_list', { items: locationListForGoogle });
    }
  }

  generateGoogleData = location => ({
    items: [
      {
        id: location.loc_id.toString(),
        name: location.localized_info.heading,
        list_name: 'List-view',
        category: location.localized_info.category_for_ga,
        list_position: location.position_index.toString(),
        price: '1.0',
      },
    ],
  });

  getLocationsList = (areas, page, removeQuery) => {
    const currentPage = page ? page : this.state.defaultPage;
    httpService.getLocationsList(areas, currentPage, this.props.kind)
      .then((response) => {
        this.setState({
          locationList: response.locations,
          pagesCount: response.page_count,
          currentPage: currentPage
        });

        this.props.receivedLocationList(response)

        if (response.page_count === 1 || removeQuery) {
          let href = window.location.href;
          let url = href.split('?');
          window.history.pushState(null, null, url[0]);
        }


        this.sendGoogleData(response.locations);
      })
      .catch((error) => {
        let href = window.location.href;
        let url = href.split('?');
        window.history.pushState(null, null, url[0]);

      });
  };

  handleDiselect = () => {
    this.setState(prevState => ({
      selectedAll: !prevState.selectedAll,
      locationList: []
    }));

    this.props.deselectAllCheckBox();
    this.handleScroll()
  };

  handleSelect = () => {
    this.setState(prevState => ({
      selectedAll: !prevState.selectedAll,
    }));
    const allAreas = this.props.arealist.map(elem => elem.id)

    this.getLocationsList(allAreas, null, true);
    this.props.selectAllCheckBox(allAreas, this.props.kind);
    this.handleScroll()
  };

  handleAddingLocationToOrder = (location, index) => {
    location.position_index = index + 1; // eslint-disable-line no-param-reassign

    if (typeof gtag === 'function') {
      gtag('event', 'add_to_cart', this.generateGoogleData(location));
    }
    this.props.droppingAnimationStart(location);
    setTimeout(() => {
      window.scrollTo(window.scrollX, window.scrollY - 1);
    }, 1500);
  };

  capitalize = s => s[0].toUpperCase() + s.substr(1);


  handleReadMoreClick() {
    this.setState({ isDescBodyShown: true });
  }

  handleReadLessClick() {
    this.setState({ isDescBodyShown: false });
  }

  handleLocationOrderedModal() {
    this.setState({ showOrderedModal: true });
  }

  handleLocationModalClose() {
    this.setState({ showOrderedModal: false });
  }

  handleChange(index, isSelected, elemId) {
    const indexArray = this.props.arealist.filter(elem => elem.checked !== false).map(elem => elem.id);
    const elemIndex = indexArray.indexOf(elemId);

    if (elemIndex === -1) {
      indexArray.push(elemId);
    } else {
      indexArray.splice(elemIndex, 1);
    }

    const areas = indexArray.length === this.props.arealist.length ? this.props.area.id : indexArray;
    this.setState({
      currentPage: this.state.defaultPage,
      areas,
    });

    this.props.onCheckBoxClick(index, isSelected, indexArray, this.props.kind);
    this.getLocationsList(areas, null, true);
    this.handleScroll()
  }

  findPos = (obj) => {
    let curtop = 0;

    if (obj.offsetParent) {
      do {
        curtop += obj.offsetTop;
      } while (obj = obj.offsetParent);

      return curtop;
    }

    return undefined;
  };

  handleScroll() {
    const orderForm = document.getElementById('main-order-form');
    const topS = this.findPos(orderForm);
    const footTop = document.getElementById("js-footer").offsetTop;
    const maxY = footTop - orderForm.offsetHeight;


    if (window.pageYOffset > (topS-11)) {
      if (window.pageYOffset < (maxY-100)) {
        orderForm.style.position = 'fixed';
        orderForm.style.top = '13px';
        orderForm.style.width = '220px';
      } else {
        orderForm.style.position = 'absolute';
        orderForm.style.top = ((maxY-100) - (topS-11)) + 'px';
        orderForm.style.width = '220px';
      }
    } else {
      orderForm.style.position = 'inherit';
      orderForm.style.top = '0px';
      orderForm.style.width = '100%';
    }
  }

  handlePageClick = (data) => {
    const service = this.httpService;
    const page = data.selected + 1;
    const startListViewSection = document.getElementById('listViewSection');

    const targetTop = this.findPos(startListViewSection) - 120;

    service.getLocationsList(this.state.areas, page, this.props.kind)
      .then((response) => {
        const query = `page=${page}`;
        const state = {query: query};
        const path = page === 1 ? '' : `?${query}`;

        window.history.pushState(state, 'title', `${window.location.pathname}${path}`);

        const { locations, page_count } = response;

        this.setState({
          currentPage: page,
          locationList: locations,
          pagesCount: page_count,
        });
        scrollTo({ top: targetTop, left: document.body, behavior: 'smooth' });

        this.sendGoogleData(locations);
      });
  }

  trackDynamicRemarketing(locationsIds) {
    const dynRemData = {
      send_to: this.props.dynRemarketingId,
      listing_id: locationsIds,
      listing_pagetype: 'list_view_show',
    };

    window.dataLayer = window.dataLayer || [];

    function gtag(...args) {
      dataLayer.push(args);
    }
    gtag('js', new Date());
    gtag('config', this.props.dynRemarketingId);
    gtag('event', 'view_item', dynRemData);
  }

  googleAnalytic(location, index) {
    sessionStorage.setItem('my.details_location_index', index);
    const itemCatalogData = {
      content_type: 'product',
      items: [
        {
          id: location.loc_id.toString(),
          name: location.localized_info.heading.toString(),
          category: location.localized_info.category_for_ga,
          list: 'Catalog',
          list_position: index,
        },
      ],
    };

    gtag('event', 'select_content', { itemCatalogData });
  }

  handleMapMouseHover = ({ target }) => {
    if (!this.state.isMapHovering) {
      target.style.background = 'white';
      this.setState({ isMapHovering: true });
    }
  };


  render() {
    const {
      area,
      arealist,
      selectedLocations,
      title,
      descTeaser,
      descBody,
      kind,
      siteKey,
      mapUrlLv,
    } = this.props;

    const {
      locIdsOrdered,
      locationList,
      pagesCount,
      staticImageAvailable,
      isMapHovering
    } = this.state;

    const mapContainerStyle = {
      position: 'absolute',
      objectFit: 'cover',
      width: '100%',
      height: '400px'
    };

    const checkAreaList = arealist.length > 0;
    const selectedLocationsIds = selectedLocations.map(location => location.loc_id);

    return (
      <div className="leftPart">
        <div className="readMoreContainer">
          <h1 className="main-color bold">
            {title}
          </h1>
        </div>
        <p>
          <span dangerouslySetInnerHTML={{ __html: descTeaser }} />
          {descBody && !this.state.isDescBodyShown && (
          <a href="#" onClick={this.handleReadMoreClick}>Read more</a>
          )}
        </p>
        {this.state.isDescBodyShown && (
          <p>
            <span dangerouslySetInnerHTML={{ __html: descBody }} />
            <a href="#" onClick={this.handleReadLessClick}>Read less</a>
          </p>
        )}
        <div className="map-wrapper"
             onMouseEnter={this.handleMapMouseHover}
             onTouchStart={this.handleMapMouseHover}
        >

          {staticImageAvailable &&
            <img
              className='bottom-location-map lazyload'
              src={mapUrlLv}
              data-sizes="auto"
              style={mapContainerStyle}
            />
          }

          { (isMapHovering || !staticImageAvailable) &&
            <MapComponent />
          }
        </div>
        <div>
          <div className="map_search">
            <div>
              <h2 className="map_search__title">
                {I18n.t(`area.map_search.map_search_title.${kind}`, { area_name: area.name })}
              </h2>
            </div>
            {checkAreaList ? (
              <div className="mapItems-wrapper">
                <div className="diselect-button">
                  {this.state.selectedAll ?
                    <button type="button" className="map_search_diselect_all" onClick={this.handleDiselect}>
                      {I18n.t('area.map_search.сlear_all')}
                    </button> :
                    <button type="button" className="map_search_diselect_all" onClick={this.handleSelect}>
                      {I18n.t('area.map_search.select_all')}
                    </button>
                  }

                </div>
                <div className="mapItems">
                  <ul>
                    {arealist.map((elem, index) => (
                      <li key={elem.id}>
                        <CheckboxComponent
                          id={elem.id}
                          link={elem.uri}
                          checked={elem.checked}
                          name={elem.name}
                          onChange={() => this.handleChange(index, elem.checked, elem.id)}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : (
              null
            )}
          </div>
        </div>
        <div className="listview-section" id="listViewSection">

          {locationList.map((location, index) => (
            <div key={location.loc_id} className="location-offices">
              <div className="row">
                <div className="col-sm-4 col-md-4">
                  <div className="listImageWrapper">
                    <div className="mapPointer">
                      <div
                        className="mapPointerMarker"
                        style={{ backgroundPosition: `-${location.colsY * 21}px -${location.rowX * 22}px` }}
                      >
                        &nbsp;
                      </div>
                    </div>
                    <div className="image-wrapper">
                      <a
                        onClick={() => this.googleAnalytic(location, index + 1)}
                        title={location.localized_info.heading}
                        href={location.url}
                      >
                        <LazyLoad once key={location.loc_id} height={150} offset={100}>
                          <img
                            className="listImage"
                            src={location.localized_info.image}
                            alt={location.localized_info.heading}
                            id={location.loc_id}
                          />
                        </LazyLoad>
                        {location.state === 'closed' && (
                          <img
                            className="rented-image"
                            src={rentedImage}
                            alt="rented out"
                          />
                        )}
                        {location.show_new_badge && (
                          <img
                            className="new-location-image"
                            src={newLocationImage}
                            alt="new location"
                          />
                        )}

                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-sm-8 col-md-8">
                  <div className="row">
                    <div className="col-sm-7 listview-description">
                      <h4 className="listview-description__mainlink">
                        <a
                          onClick={() => this.googleAnalytic(location, index + 1)}
                          className="listview-description__headelink"
                          href={location.url}
                        >
                          {location.address_title}
                        </a>
                      </h4>
                      <div className="listview-description__description-text">
                        <ReadMore
                          lines={3}
                          more={I18n.t('list_view.read_more')}
                          less={I18n.t('list_view.read_less')}
                          readMore={false}
                        >
                          {location.localized_info.desc}
                        </ReadMore>
                      </div>
                      <div className="listview-description__info-buttons">
                        <span className="read-more-button">
                          <a
                            onClick={() => this.googleAnalytic(location, index + 1)}
                            href={location.url}
                            title={I18n.t('list_view.get_more_info')}
                          >
                            {I18n.t('list_view.read_more')}
                          </a>
                        </span>
                        {(locIdsOrdered.indexOf(location.loc_id) > -1) ? (
                          <span>
                            <button
                              type="button"
                              className="button--link"
                              onClick={this.handleLocationOrderedModal}
                            >
                              {I18n.t('list_view.location_was_ordered')}
                            </button>
                          </span>
                        ) : (
                          <span>
                            {location.state !== 'closed' && (
                              <span>
                                {(selectedLocationsIds.indexOf(location.loc_id) >= 0) && (
                                  <span className="get-price-button">
                                    {I18n.t('list_view.bussiness_center_is_selected')}
                                  </span>
                                )}
                                {(selectedLocationsIds.indexOf(location.loc_id) === -1) && (
                                  <span className="get-price-button">
                                    {siteKey === 'be'
                                      ? (<Experiment ref="experiment" name="button-text">
                                          <Variant name="one-text">
                                            <button
                                              type="button"
                                              className="button--link old-text"
                                              onClick={() => this.handleAddingLocationToOrder(location, index)}
                                            >
                                              {I18n.t('list_view.get_info_and_prices')}
                                            </button>
                                          </Variant>

                                          <Variant name="second-text">
                                            <button
                                              type="button"
                                              className="button--link new-text"
                                              onClick={() => this.handleAddingLocationToOrder(location, index)}
                                            >
                                              Ontvang info
                                            </button>
                                          </Variant>
                                        </Experiment>
                                        )
                                      : (<button
                                          type="button"
                                          className="button--link"
                                          onClick={() => this.handleAddingLocationToOrder(location, index)}
                                        >
                                          {I18n.t('list_view.get_info_and_prices')}
                                        </button>
                                      )
                                    }
                                  </span>
                                )}
                              </span>
                            )}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-5 listview-overview">
                      <div className="marker-rating">
                        <p className="marker-rating__category">
                          {I18n.t('list_view.map.info_window.standard')}
                          :
                        </p>
                        <div className="location-rating">
                          {[...Array(location.stars_rating)].map(elem => (
                            <StarRateIcon key={elem} />
                          ))}
                        </div>
                      </div>
                      <div className="office-short-info">
                        <p>
                          {I18n.t('list_view.map.info_window.office_size')}
                          { location.area_humanized }
                        </p>
                      </div>
                      <div className="location-type">
                        <p>
                          { location.translated_kind }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        { locationList.length > 0 && pagesCount > 1
          ? (
            <div className="pagination-container">
              <div className="pagination-wrapper">
                <ReactPaginate
                  previousLabel={<span className="circle left" />}
                  nextLabel={<span className="circle right" />}
                  pageCount={Math.ceil(pagesCount)}
                  breakLabel="..."
                  pageRangeDisplayed={2}
                  marginPagesDisplayed={1}
                  onPageChange={this.handlePageClick}
                  containerClassName="pagination"
                  activeClassName="active"
                  forcePage={this.state.currentPage - 1}
                />
              </div>
            </div>
          )
          : null
        }
        <Modal
          className="header-modals"
          show={this.state.showOrderedModal}
          onHide={this.handleLocationModalClose}
        >
          <Modal.Header closeButton />
          <Modal.Body>

            <div>
              <h3><strong>{I18n.t('location.detailed_view.location_ordered_title')}</strong></h3>
              <p>{I18n.t('location.detailed_view.location_ordered')}</p>
            </div>
            <p dangerouslySetInnerHTML={{ __html: I18n.t('provider_signup.page.contacts') }} />

          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

CityLeftPartComponent.propTypes = {
  area: PropTypes.oneOfType([PropTypes.object]),
  arealist: PropTypes.arrayOf(PropTypes.shape),
  selectedLocations: PropTypes.arrayOf(PropTypes.object),
  onComponentDidMount: PropTypes.func,
  onCheckBoxClick: PropTypes.func,
  deselectAllCheckBox: PropTypes.func,
  droppingAnimationStart: PropTypes.func,
  dynRemarketingId: PropTypes.string,
  title: PropTypes.string,
  descTeaser: PropTypes.string,
  descBody: PropTypes.string,
  pagesCount: PropTypes.number,
};

CityLeftPartComponent.defaultProps = {
  area: {},
  arealist: [],
  selectedLocations: [],
  onComponentDidMount: () => null,
  onCheckBoxClick: () => true,
  deselectAllCheckBox: () => true,
  droppingAnimationStart: () => true,
  dynRemarketingId: '',
  title: '',
  descTeaser: '',
  descBody: '',
  pagesCount: 0,
};

export default CityLeftPartComponent;
